/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line



// ----------------- MINIMUM QUANTITY PRODUCT SELECTION -------------------------- //
// _____ FOR PRODUCT PAGE _____
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-minimum-quantity]').forEach(function (selector) {
    var minimum = parseInt(selector.getAttribute('data-minimum-quantity'), 10);
    var input = selector.querySelector('[data-quantity-field]');

    if (!minimum || minimum <= 1 || !input) {
      return;
    }

    input.setAttribute('min', minimum);

    // Set the initial quantity after Palo Alto has initialized the selector.
    requestAnimationFrame(function () {
      input.value = minimum;
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });

    // Prevent the minus button from going below the minimum.
    var minusButton = selector.querySelector('[data-quantity-minus]');

    if (minusButton) {
      minusButton.addEventListener('click', function (event) {
        if (parseInt(input.value, 10) <= minimum) {
          event.preventDefault();
          event.stopImmediatePropagation();
          input.value = minimum;
        }
      }, true);
    }

    // Prevent manually entering a quantity below the minimum.
    input.addEventListener('input', function () {
      var value = parseInt(input.value, 10);

      if (!value || value < minimum) {
        input.value = minimum;
      }
    });

    input.addEventListener('change', function () {
      var value = parseInt(input.value, 10);

      if (!value || value < minimum) {
        input.value = minimum;
      }
    });

    // Remove dropdown options below the minimum.
    selector.querySelectorAll('[data-popout-option]').forEach(function (option) {
      var value = parseInt(option.getAttribute('data-value'), 10);

      if (value < minimum) {
        var item = option.closest('.select-popout__item');

        if (item) {
          item.remove();
        }
      }
    });
  });
});

// _____ FOR CART _____
document.addEventListener('click', function (event) {
  var minusButton = event.target.closest('[data-quantity-minus]');

  if (!minusButton) {
    return;
  }

  var quantityHolder = minusButton.closest('[data-quantity-holder]');
  var input = quantityHolder ? quantityHolder.querySelector('[data-quantity-field]') : null;

  if (!input) {
    return;
  }

  var minimum = parseInt(input.getAttribute('data-minimum-quantity'), 10);

  if (!minimum || minimum <= 1) {
    return;
  }

  var current = parseInt(input.value, 10) || minimum;

  if (current <= minimum) {
    event.preventDefault();
    event.stopImmediatePropagation();
    input.value = minimum;
  }
}, true);


document.addEventListener('input', function (event) {
  var input = event.target.closest('[data-quantity-field][data-minimum-quantity]');

  if (!input) {
    return;
  }

  var minimum = parseInt(input.getAttribute('data-minimum-quantity'), 10);

  if (!minimum || minimum <= 1) {
    return;
  }

  var value = parseInt(input.value, 10);

  if (!value || value < minimum) {
    input.value = minimum;
  }
}, true);


document.addEventListener('change', function (event) {
  var input = event.target.closest('[data-quantity-field][data-minimum-quantity]');

  if (!input) {
    return;
  }

  var minimum = parseInt(input.getAttribute('data-minimum-quantity'), 10);

  if (!minimum || minimum <= 1) {
    return;
  }

  var value = parseInt(input.value, 10);

  if (!value || value < minimum) {
    event.preventDefault();
    event.stopImmediatePropagation();
    input.value = minimum;
  }
}, true);
// --------------- END MINIMUM QUANTITY PRODUCT SELECTION ------------------------ //



  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
